var $76c292be85991194$exports = {};
$76c292be85991194$exports = {
    "endTime": `Zavr\u{161}no vreme`,
    "startTime": `Po\u{10D}etno vreme`,
    "time": `Vreme`
};


export {$76c292be85991194$exports as default};
//# sourceMappingURL=sr-SP.module.js.map
